document.addEventListener('DOMContentLoaded', () => {
  const heroVideo = document.getElementById('vidHome_html5')
  const btnVideoToggle = document.getElementById('btnHeroVideoToggle')

  if (!heroVideo || !btnVideoToggle) {
    return // exit if elements are not found
  }

  // spans inside the button
  const spanVideoIcon = btnVideoToggle.querySelector('span[aria-hidden="true"]')
  const spanVideoText = btnVideoToggle.querySelector('.title')

  // check spans exist
  if (!spanVideoIcon || !spanVideoText) {
    return // exit if elements are not found
  }

  // event listener for the button
  btnVideoToggle.addEventListener('click', () => {
    if (heroVideo.paused) {
      heroVideo.play() // play the video
      spanVideoIcon.className = 'szicon-pause-button'
      spanVideoText.textContent = 'Pause Video'
      btnVideoToggle.setAttribute('aria-pressed', 'false')
    } else {
      heroVideo.pause() // pause the video
      spanVideoIcon.className = 'szicon-play-button'
      spanVideoText.textContent = 'Play Video'
      btnVideoToggle.setAttribute('aria-pressed', 'true')
    }
  })

  // hero video - hide on small viewports
  const isSmallView = window.innerWidth <= 640

  if (isSmallView) {
    heroVideo.parentElement.removeChild(heroVideo)
    btnVideoToggle.style.display = 'none'
  }
})
